import {analyticsEvent} from './analyticsEvent';
let trackingElements;

const _track = (trackingElem, event) => {
    analyticsEvent(trackingElem.getAttribute('data-event-category'), event, trackingElem.getAttribute('data-event-label'));
};

/* EXAMPLE */
/* <button data-event="click" data-event-category="Button" data-event-label="Play"> */

const init = root => {
    root = root || document;

    if (!root || typeof root.querySelectorAll === 'undefined') return;

    /* track events from html attributes */
    trackingElements = [...root.querySelectorAll('[data-event][data-event-category][data-event-label]')];

    if (trackingElements.length > 0) {
        trackingElements.forEach(trackingElem => {
            const data = trackingElem.data || {};
            const event = trackingElem.getAttribute('data-event');
            if (data.__trackingEvent === event) return;
            data.__track = () => {
                _track(trackingElem, event);
            };
            data.__trackingEvent = event;
            trackingElem.data = data;
            trackingElem.addEventListener(event, data.__track);
        });
    }
};

const destroy = root => {
    root = root || document;

    if (!root || typeof root.querySelectorAll === 'undefined') return;

    /* track events from html attributes */
    trackingElements = [...root.querySelectorAll('[data-event][data-event-category][data-event-label]')];

    if (trackingElements.length > 0) {
        trackingElements.forEach(trackingElem => {
            const data = trackingElem.data;
            if (!data) return;
            trackingElem.removeEventListener(data.__trackingEvent, data.__track);
            delete data.__trackingEvent;
            delete data.__track;
        });
    }
};

const elementsTracking = {
    init,
    destroy
};

export {init, destroy, elementsTracking};
